import Button from "../../Button/Button";
import { useForm, Controller } from "react-hook-form";
import useUser from "../../../hooks/useUser";
import PasswordInput from "../../PasswordInput/PasswordInput";
import TextInput from "../../TextInput/TextInput";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

interface LoginFormValues {
    email: string;
    password: string;
}

const LoginForm = () => {
    const navigate = useNavigate();

    const { isLoading, onSignIn, errors: responseError } = useUser();

    const {
        handleSubmit,
        control,
        formState: { errors, dirtyFields },
    } = useForm<LoginFormValues>({
        mode: "onBlur",
    });

    const isSubmitButtonDisabled =
        isLoading || Object.keys(errors).length > 0 || !dirtyFields.email || !dirtyFields.password;

    return (
        <div className={styles.container}>
            <div className={styles.or}>
                <span> OR </span>
            </div>
            <form
                className={styles.form}
                onSubmit={handleSubmit(data => {
                    if (Object.keys(errors).length !== 0) return null;
                    onSignIn({ email: data.email, password: data.password });
                })}
            >
                <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{
                        required: "This field is required.",
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "That’s an invalid e-mail",
                        },
                    }}
                    render={({ field }) => (
                        <TextInput
                            label="Email"
                            placeholder="example@example.com"
                            onChange={event => field.onChange(event.target.value)}
                            error={errors.email && errors.email.message}
                        />
                    )}
                />
                <Controller
                    name="password"
                    control={control}
                    rules={{
                        required: "This field is required",
                        minLength: {
                            value: 8,
                            message: "Password must contain at least 8 characters",
                        },
                    }}
                    render={({ field }) => (
                        <PasswordInput
                            label="Password"
                            error={
                                (errors.password && errors.password.message) ||
                                (responseError?.data?.error && responseError?.data.error)
                            }
                            onChange={event => field.onChange(event.target.value)}
                        />
                    )}
                />
                <Button
                    mode="text"
                    type="button"
                    className={styles.forgot_button}
                    onClick={() => navigate("/forgot-password")}
                >
                    Forgot Password?
                </Button>
                <Button type="submit" mode="filled" disabled={isSubmitButtonDisabled}>
                    LogIn
                </Button>
            </form>
        </div>
    );
};

export default LoginForm;
